import { Box, Stack } from '@mantine/core';
import {
	fetchApiMemberEnv,
	fetchCreateIntent,
	useGetAiTokenCredits,
} from '@repo/api-codegen';
import { loadStripe } from '@stripe/stripe-js';
import { useCallback } from 'react';
import { AutoReloadSettingsController } from '../../features/AutoReloadSettings';
import { BudgetSettingsController } from '../../features/BudgetSettings';
import { BuyCreditsModalController } from '../../features/BuyCreditsModal';
import { InvoiceHistoryController } from '../../features/InvoiceHistory';
import { closeAllModals, openModal } from '../ModalManager';
import { PaymentMethodSettings } from './PaymentMethodSettings';
import { RemainingBalanceSettings } from './RemainingBalanceSettings';
import { StripePaymentMethodModal } from './StripePaymentMethodModal';

export function AiBillingSettings() {
	const { refetch: refetchCredits } = useGetAiTokenCredits({});

	const handleEditCard = useCallback(async () => {
		const publicEnv = await fetchApiMemberEnv({});
		const clientSecret = await fetchCreateIntent({
			body: {
				return_url: window.location.href,
			},
		});

		if (!publicEnv?.STRIPE_PUBLISHABLE_KEY || !clientSecret?.client_secret) {
			return;
		}

		const stripeInstance = loadStripe(publicEnv?.STRIPE_PUBLISHABLE_KEY);

		openModal({
			title: 'Update Payment Method',
			children: (
				<StripePaymentMethodModal
					clientSecret={clientSecret?.client_secret}
					stripeInstance={stripeInstance}
					type={clientSecret?.type}
					onSuccess={() => {
						closeAllModals();
					}}
					onCancel={() => {
						closeAllModals();
					}}
				/>
			),
		});
	}, []);

	const handleBuyCredits = useCallback(() => {
		openModal({
			title: 'Buy credits',
			children: (
				<BuyCreditsModalController
					onPurchase={() => {
						closeAllModals();
						refetchCredits();
					}}
				/>
			),
		});
	}, [refetchCredits]);

	return (
		<Stack spacing="md">
			<Stack spacing={0}>
				<RemainingBalanceSettings />
				<PaymentMethodSettings
					onEditCard={handleEditCard}
					onBuyCredits={handleBuyCredits}
				/>
			</Stack>

			<Box>
				<BudgetSettingsController />
			</Box>

			<Box>
				<AutoReloadSettingsController />
			</Box>

			<Box>
				<InvoiceHistoryController />
			</Box>
		</Stack>
	);
}
